export default function GoodsAction({ children, className }) {
  return (
    <div className={`fixed flex bg-white w-[100%] z-50 left-0 bottom-0 md:hidden ${className}`}>
      {children}
    </div>
  );
}
